import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class PeripheralDbTableDefinition extends DbTableDefinition {
    tableName = 'peripheral';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       databag LONGTEXT,
       label TEXT,
       name TEXT,
       description TEXT,
       type TEXT,
       mac TEXT,
       softwareid TEXT,
       lookupname TEXT,
       connectedmac TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
         this.updateStatements.set(7, [`CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`]);
      }
}